export default "__VITE_ASSET__BZG3OR7S__"